import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { ReactComponent as DeleteIcon } from '../../../assets/icons/delete.svg';
import { pathJoin } from '../../../services/api';
import { useHasPermission } from '../../../services/auth/auth';
import { css } from '../../../services/css';
import { AddSystemAuthorization } from '../../shared/actions/actionButtons';
import { DeleteResource } from '../../shared/actions/deleteResource';
import { Button } from '../../shared/inputs/button';
import { Telephone } from '../../shared/links/telephone';
import { SystemList } from '../systemAccess/systemList';
import { SystemStatus } from '../systemAccess/systemStatus';

import { SYSTEM, USER } from '../../../permissions';
import styles from './authorizedSystemList.module.css';

const writePermissions = [SYSTEM.WRITE, USER.READ];
const readPermissions = [SYSTEM.READ, USER.READ];

export const SystemAuthorizationsList = ({
    refreshData,
    isArchived = true,
    ...props
}) => {

    const [systemAccessAuthorizationToDelete, setSystemAccessAuthorizationToDelete] = useState(null);
    const [refreshToken, setRefreshToken] = useState('');
    const canWrite = useHasPermission(writePermissions);
    const canRead = useHasPermission(readPermissions);
    

    const refreshDataLocal = () => {
        setRefreshToken(Math.random().toString());
        refreshData();
    }

    const columns = () => {
        let c = {
            status: {
                label: 'Status',
                size: '75px',
                formatFunction: r => <SystemStatus status={r.status} />,
            },
            name: {
                label: 'Name',
                passOnClick: true,
                formatFunction: r => <Link to={pathJoin('/systemAccess', r.id)}>{r.name}</Link>,
            },
            authorizedUserCount: {
                label: 'Authorized Users',
            },
            helpITPhone: {
                label: 'IT Helpdesk Phone',
                formatFunction: r => <Telephone number={r.helpITPhone} />,
            }
        };

        if (canWrite && !isArchived)
            c.delete = {
                label: '',
                size: '64px',
                formatFunction: r => <Button
                    className={css(styles.Delete, 'icon')}
                    title='Remove as Accessible System'
                    onClick={()  => setSystemAccessAuthorizationToDelete(r)}
                >
                    <DeleteIcon />
                </Button>,
            };

        return c;
    }


    return <>
        <DeleteResource
            resourceName='Accessible System'
            name={systemAccessAuthorizationToDelete?.name}
            customMessage={`Are you sure you want to remove ${systemAccessAuthorizationToDelete?.name} as an accessible system?`}
            restEndpoint={pathJoin('/systemAccess', systemAccessAuthorizationToDelete?.id, 'authorizedUsers')}
            ids={[props.scope]}
            successCallback={() => {
                setSystemAccessAuthorizationToDelete(null);
                refreshDataLocal();
            }}
            errorCallback={() => setSystemAccessAuthorizationToDelete(null)}
            cancelCallback={() => setSystemAccessAuthorizationToDelete(null)}
            prompt={systemAccessAuthorizationToDelete !== null}
        />
        <SystemList
            queryParamPrefix='h_'
            maxResults={10}
            actions={!isArchived ? [AddSystemAuthorization] : []}
            readPermissions={readPermissions}
            writePermissions={writePermissions}
            columns={columns()}
            refreshToken={refreshToken}
            {...props}
        />
    </>
}